import React from "react";
import Users from "../Components/Users/Users";
import Search from "../Components/Molecules/Search";
import Alert from "@material-ui/lab/Alert";
import { Container } from "@material-ui/core";

const HomePage = (props) => {
  return (
    <div>
      <Search
        onChangeHandler={props.onChangeHandler}
        onSubmit={props.onSubmitHandler}
        clearUsers={props.onClearUsers}
        show={props.users.length > 0}
        text={props.text}></Search>
      <Container>
        {props.showAlert ? (
          <Alert variant="outlined" severity="error">
            Please enter a username !
          </Alert>
        ) : (
          <Users users={props.users} loading={props.loading}></Users>
        )}
      </Container>
    </div>
  );
};

export default HomePage;
